import Vue from "vue";
import { Mutation, State } from "vuex-class";
import { Component } from "vue-property-decorator";

@Component
class LayoutView extends Vue {
  @State(state => state.app.settings) settings;

  @Mutation("app/SET_SETTINGS") setSettings;
}

export default LayoutView;
